<template>
  <div>
    <index-card :loading="paymentType == null">
      <template slot="header">
        <div class="payment-opts-header d-flex align-center">
          <v-btn text icon large to="/" exact class="payment-opts-back">
            <v-icon class="white--text">mdi-arrow-left</v-icon>
          </v-btn>
          <v-tabs
            v-model="tabs"
            class="payment-opts-tabs"
            slider-color="white"
            centered
            flat
            dark
            grow
            icons-and-text
            background-color="transparent"
          >
            <v-tab v-for="(head, index) in tabItem" :key="index">
              {{ head.name }}
              <v-icon>{{ head.icon }}</v-icon>
            </v-tab>
          </v-tabs>
        </div>
      </template>
      <template slot="subheader">
        <div class="payment-opts-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Pesquisar"
            @doneFilter="handleDoneFilter"
          />
        </div>
      </template>
      <template slot="data_table">
        <v-tabs-items v-model="tabs" class="payment-opts-table-items">
          <v-tab-item v-for="(item, index) in tabItem" :key="'dt-' + index">
            <v-data-table
              v-if="paymentType != null"
              class="payment-opts-table elevation-0"
              :headers="item.headers"
              :items="paymentType"
              :search="search"
              mobile-breakpoint="1"
            >
              <template v-slot:no-results>
                <v-alert :value="true" type="error" icon="mdi-alert">
                  Não foi possível encontrar "{{ search }}" em {{ item.name }}.
                </v-alert>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </index-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'IndexPaymentOptions',
  components: {
    IndexCard: () => import('@/_backoffice/_registrations/components/shared/index/IndexCard.vue'),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      search: '',
      tabs: 0,
      paymentType: null,
      tabItem: [
        {
          id: 1,
          name: 'Formas de Pagamento',
          icon: 'mdi-currency-usd',
          headers: [
            { text: 'Nome', value: 'attributes.display_name', align: 'center' },
            { text: 'Custo Base', value: 'attributes.costBase', align: 'center' },
          ],
        },
        {
          id: 2,
          name: 'Prazos de Pagamento',
          icon: 'mdi-calendar',
          headers: [
            { text: 'Descrição', value: 'attributes.description', align: 'center' },
            { text: 'Custo Base', value: 'attributes.costBase', align: 'center' },
          ],
        },
      ],
    };
  },
  methods: {
    getData() {
      this.getPayModals('options');
      this.getPayModals('times');
      this.paymentType = this.allPayOpts;
      this.tabs = 0;
    },
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : '';
    },
    ...mapActions({
      getPayModals: 'PaymentOption/index',
      clearPaymentOption: 'PaymentOption/clearPaymentOption',
      clearAllPaymentOptions: 'PaymentOption/clearAllPaymentOptions',
    }),
  },
  computed: mapState({
    allPayOpts: (state) => state.PaymentOption.allPayOpts,
    allPayTimes: (state) => state.PaymentOption.allPayTimes,
    onePayOpt: (state) => state.PaymentOption.onePayOpt,
    onePayTime: (state) => state.PaymentOption.onePayTime,
  }),
  watch: {
    tabs(newValue) {
      if (newValue == 0) {
        this.paymentType = this.allPayOpts;
      } else if (newValue == 1) {
        this.paymentType = this.allPayTimes;
      }
    },
    allPayOpts(newValue) {
      this.paymentType = newValue;
    },
    '$route.params.get_list'(nv, old) {
      this.getData();
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.payment-opts-header {
  width: 100%;
  min-width: 0;
  gap: 4px;
}

.payment-opts-back {
  flex-shrink: 0;
}

.payment-opts-tabs {
  flex: 1 1 auto;
  min-width: 0;
}

/* Herda o gradiente do IndexCard — sem segunda camada blue-grey */
.payment-opts-tabs >>> .v-tabs-bar {
  background: transparent !important;
}

.payment-opts-table-items {
  width: 100%;
  background: transparent !important;
}

.payment-opts-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}

.payment-opts-filters >>> .filter-data-card {
  width: 100%;
}

.payment-opts-table {
  background: transparent;
}
</style>
